/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Err_Invalid_UrlInputs */

const en_rd_err_invalid_url = /** @type {(inputs: Rd_Err_Invalid_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is not a GitHub repository URL. Use https://github.com/owner/repo.`)
};

const id_rd_err_invalid_url = /** @type {(inputs: Rd_Err_Invalid_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itu bukan URL repo GitHub. Pakai https://github.com/pemilik/repo.`)
};

/**
* | output |
* | --- |
* | "That is not a GitHub repository URL. Use https://github.com/owner/repo." |
*
* @param {Rd_Err_Invalid_UrlInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_err_invalid_url = /** @type {((inputs?: Rd_Err_Invalid_UrlInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Err_Invalid_UrlInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_err_invalid_url(inputs)
	return en_rd_err_invalid_url(inputs)
});